/**
 * @Author: Zero
 * @Date: 2025-02-18 11:12:03
 * @Explain: AB 活动枚举信息
 */

// 实验获胜判定方式
export enum ExpWinningCriteriaEnum {
  /** 手动选择 */
  SELECT_MANUALLY = 2,
  /** 自动选择 */
  AUTOMATIC_SELECTION = 1,
}

// 关联选择实验结束后多久时间自动观测指标单位
export enum ExpWinningCriteriaExtendTypeEnum {
  /** 小时 */
  HOURS = 1,
  /** 天 */
  DAYS = 2,
}

// 实验阶段
export enum ExpStageEnum {
  /** test in progress(实验中) */
  TEST_IN_PROGRESS = 1,
  /** 剩余流量投递中 */
  ONGOING = 2,
}
